import { gql } from 'apollo-angular';

export const ColumnFragment = gql`
  fragment Column on ColumnOutput {
    id
    coordinate
  }
`;
